import { useParamsControl } from '../../../../utils/useParamsControl'
import { IBuffetDishesRequest } from '../../../../core/api/dto/BuffetDishDto'
import { useGetBuffetDishQuery } from '../../../../core/api/BuffetDishApi'
import { createQueryString } from '../../../../utils/createQueryString'
import { GetFile } from '../../../../utils/getFile'
import { BASE_URL } from '../../../../core/api/BaseApi'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useGetBuffetDishData = () => {
  const { t } = useTranslation()
  const [isLoadingLocal, setIsLoadingLocal] = useState<boolean>(false)

  const pageParams = useParamsControl<
    IBuffetDishesRequest,
    keyof IBuffetDishesRequest
  >({
    withPagination: true,
    whiteList: [
      'search',
      'archived',
      'ordering',
      'category',
      'ids',
      'edge_servers',
    ],
  })
  const {
    data: buffetDishesData,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetBuffetDishQuery(
    {
      ...pageParams,
      ordering: !!pageParams?.ordering
        ? pageParams?.ordering.replace(
            '-standard_temp_min,standard_temp_max',
            '-standard_temp_min,-standard_temp_max',
          )
        : undefined,
    },
    { skip: !pageParams },
  )

  const unloadDishesHandler = () => {
    setIsLoadingLocal(true)
    const params = createQueryString(pageParams)
    GetFile(`${BASE_URL}/buffet_dish/export_dishes_to_file/${params}`)
      .then(() =>
        AppNotification({
          msg: t('Выбранные блюда успешно выгружены!'),
          type: NotificationType.success,
        }),
      )
      .finally(() => setIsLoadingLocal(false))
  }

  return {
    buffetDishesData,
    isLoadingGet,
    isFetchingGet,
    pageParams,
    unloadDishesHandler,
    isLoadingLocal,
  }
}
